import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
import { CHECKOUT_URL } from './Shared';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 14,
    s: 5
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/45 bg-brand-deep text-white shadow-[0_4px_18px_rgba(8,4,20,0.5)]" data-id="element-252" data-mp="1bwgcr7f6ljyd">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2.5 px-3 py-1 text-[10px] font-medium sm:gap-4 md:px-6 md:text-[11px]" data-id="element-253" data-mp="1gw2qdhyx927p">
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-goldLight" data-id="element-254" data-mp="22n7z12mz5c2b">
          <span className="relative flex h-1.5 w-1.5" aria-hidden="true" data-id="element-255" data-mp="1xpydvz6mbmka">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-256" data-mp="1sq3j3kjq2cty" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand-amber" data-id="element-257" data-mp="2qdu4qn9iak95" />
          </span>
          <strong className="uppercase tracking-[0.1em]" data-id="element-258" data-mp="2lfiuwcj7o9qx">
            Oferta de lanzamiento
          </strong>
        </div>
        <span className="h-3 w-px bg-brand-gold/45" aria-hidden="true" data-id="element-259" data-mp="2gdl858blqwt8" />
        <div className="flex items-center gap-1.5 whitespace-nowrap text-white" data-id="element-260" data-mp="2ccrlsjdt5q2g">
          <ClockIcon className="h-3 w-3 text-brand-goldLight" aria-hidden="true" data-id="element-261" data-mp="150hozbi7inst" />
          <span className="hidden sm:inline" data-id="element-262" data-mp="10xl41e572flp">Finaliza en</span>
          <span className="font-mono font-bold tabular-nums text-brand-goldLight" data-id="element-263" data-mp="12g2vocga9zk6">
            {formattedTime}
          </span>
        </div>
        <a href={CHECKOUT_URL} className="rounded-full bg-brand-gold px-2 py-0.5 text-[9px] font-bold uppercase text-brand-deep transition-colors duration-150 hover:bg-brand-goldLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-goldLight sm:px-2.5 sm:text-[10px]" data-id="element-264" data-mp="17dl8wf1c30xz">
          VER PACK →
        </a>
      </div>
    </div>;
}